import { fromJS } from 'immutable';
import { VALUE_CHANGED, RESET, LOAD } from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    signature: null,
    electronicConsentDocument: null,
    emailAddress: '',
    validateFromData: null,
    declarationSignature: null,
    privacyActAuthorisationSignature: null,
    warningMissingRequiredDocument: '',
  },
});


function stepDeclarationReducer(state = initialState, action) {
  const properties = (action.propertyName) ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case RESET:
      return initialState;
    case LOAD:
      return action.payload ? fromJS({ form: action.payload }) : initialState;
    default:
      return state;
  }
}

export default stepDeclarationReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/reducer.js